var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModernTable',{attrs:{"region":_vm.priorOwnersTable.region,"filters":_vm.priorOwnersTable.filters,"rows":_vm.list,"columns":_vm.priorOwnersTable.columns,"headerColor":"#FFF","condensed":""}})}
var staticRenderFns = []

export { render, staticRenderFns }